export default __webpack_public_path__ + "e4b5ae424a45c5a8233323137d16e4a7.svg";